
/**
 * MedicationSchedule Component - Main Entry Point
 * 
 * This component serves as a redirect to the fully featured MedicationSchedule component
 * in the MedicationSchedule folder. It preserves backward compatibility while ensuring
 * all existing functionality is maintained.
 */
import React, { useEffect } from 'react';
import { useViewPerformance } from '@/hooks/useViewPerformance';
import { useMedicationStore } from '@/store/medicationStore';
import type { Medication } from '@/types/medication';
import { MedicationSchedule as MedicationScheduleMain } from './MedicationSchedule/index';

/**
 * This is a wrapper component that redirects to the full implementation
 * while maintaining backward compatibility with any code that might be
 * using this direct import path.
 */

export interface MedicationScheduleProps {
  isDemo?: boolean;
  initialMedications?: Medication[];
}

/**
 * MedicationSchedule Component
 * This component forwards all props to the full implementation.
 */
export const MedicationSchedule: React.FC<MedicationScheduleProps> = (props) => {
  const { measureOperation } = useViewPerformance("MedicationSchedule");
  
  // Measure component render performance
  useEffect(() => {
    measureOperation("render");
  }, [measureOperation]);

  // Forward all props to the full implementation
  return <MedicationScheduleMain {...props} />;
}
